import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Modal,
} from "@mui/material";
import { ReactElement, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BacktestingResultTable from "../BacktestingResultTable/BacktestingResultTable";
import { DataShownDialog } from "../../Datashow";
import closeButton from "../../../images/closeButton.svg";
import rectanglePink from "../../../images/rectanglePinkLight.svg";
import rectangleBlue from "../../../images/rectangleBlue.svg";
import rectangleDarkPink from "../../../images/rectangleDarkPink.svg";
import rectangleTer from "../../../images/rectangleTer.svg";
import rectangleAux from "../../../images/rectangleAux.svg";
import rectangleLightOrange from "../../../images/rectangleLightOrange.svg";
import rectangleYellow from "../../../images/rectangleYello.svg";
import rectanglePurpleExp from "../../../images/rectanglePurpleExp.svg";
import rectanglePurpleLight from "../../../images/rectanglePurpleLight.svg";
import enlargeButton from "../../../images/enlargeButton.svg";
import ovalDarkPink from "../../../images/ovalDarkPink.svg";
import ovalAux from "../../../images/ovalAux.svg";
import ovalTer from "../../../images/ovalTer.svg";
import ovalDarkBlueExp from "../../../images/ovalDarkBlueExp.svg";
import ovalRank1 from "../../../images/ovalRank1.svg";
import ovalRank3 from "../../../images/ovalRank3.svg";
import ovalRank2 from "../../../images/ovalRank2.svg";
import { RootState } from "../../../store/store";
import loadingSvg from "../../../images/bouncing-circles.svg";
import settingsIcon from "../../../images/Settings.svg";
import {
  updateExperinemtBackTestingTotalPages,
  updateExperinemtBackTestingPageNumber,
  resultVisulizationExperimentBackTestingTableDataSetter,
} from "../../../store/resultVisualizationExperimentation";
import { Pagination } from "../../Pagination";
import {
  calculateTotalPages,
  resultVisulizationExperimentDefaultGroupBy,
  mapperForGroupByLableToKey,
  resultVisualisationChartExperimentaionTableApi,
} from "../../../api/forecastPageApi";
import { useOktaAuth } from "@okta/okta-react";
import { PAGE_LIMIT } from "../../../utils/constant";
import { BacktestingResultsProps } from "../../../store/foreCastBackTestingDataSlice";
import LagDropdown from "./LagDropDown";
import LineColumnChartExp from "../../chart/LineColumn/LineColumnChartExp";
import RankDropdownForward from "./RankDropDown";
import { DynamicMappings } from "../../../utils/dynamicMappings";
import { isValidBackTestingChart } from "../../../utils/functions";

type DataPoint = {
  accuracy: number;
  bias: number;
  statisticalForecast: number;
  historicalShipment: number;
  timeFrameDate: string;
  periodWeekNumber: string;
  experimentId: string;
  rank: number;
  measurement: boolean;
};

function ResultVisulizationExperimentBacktestingResults({
  isResultVisulizationPage,
  measurementPayload,
  isPredefined,
}: BacktestingResultsProps) {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [expChartData, setChartDataExp] = useState<any>([]);
  const [expChartDataLabels, setChartDataExpLabels] = useState<any>([]);
  const { authState } = useOktaAuth();
  const dataShowKeyValueMappings = DynamicMappings();
  const [showMeasurement, setShowMeasurement] = useState<any>(true);
  const [showOutput, setShowOutput] = useState<any>(true);

  const [payloadExcelGroup, setPayloadExcelGroup] = useState<string[]>([]);
  const [selectedDataShownCategoryList, setSelectedDataShownCategoryList] =
    useState<string[]>([]);

  const userData = useSelector((state: RootState) => state.user);

  const [selectedDataShownOptionList, setSelectedDataShownOptionList] =
    useState(
      userData?.sections?.predefinedRunsExperimentation?.table?.defaultDataShown
        ?.backTesting
    );
  const expData = useSelector(
    (state: RootState) => state.resultVisualizationExperimentationData
  );
  const resultVisulizationExperimentBackTestingTableDataSlice = useSelector(
    (state: RootState) =>
      state.resultVisulizationExperimentBackTestingTableDataSlice
  );

  const resultVisulizationExperimentTestingDataLoadingSlice = useSelector(
    (state: RootState) =>
      state.resultVisulizationExperimentTestingDataLoadingSlice
  );

  const resultVisualizationExperimentationData = useSelector(
    (state: RootState) => state.resultVisualizationExperimentationData
  );

  const loader = useSelector(
    (state: RootState) => state.resultVisualizationData
  );

  const lagDropdownData = useSelector(
    (state: RootState) => state.lagDropdownData
  );

  const [openSettings, setOpenSettings] = useState(false);

  const filter = useSelector(
    (state: RootState) => state.resultVisualizationExpFilter
  );

  const resultVisulizationBackTestingPaginationDate = useSelector(
    (state: RootState) =>
      state.resultVisulizationExperimentBackTestingPagination
  );

  const payloadFilters = {
    shortTermMidTermCode: filter?.term.toString(),
    snapshotDate: [],
    brandName: filter?.brand,
    subBrandName: filter?.subBrand,
    productLineName: filter?.productLine,
    productGroupName: filter?.productGroup,
    materialGlobalTradeItemNumberDescription: filter?.planningItem,
    packageSizeName: filter?.size,
    productCategoryName: filter?.category,
    eachUPC: filter?.eachUPC,
    portfolioGroupName: filter?.mg4PortfolioGroup,
    packageName: filter?.count,
    packTypeName: filter.ppg,
    keyAccount: filter?.keyAccount,
    customerGlobalName: filter?.global,
    customerSectorNumber: filter?.customerSector,
    customerRegionName: filter?.customerRegion,
    customerGroupName: filter?.customerGroup,
    customerBusinessUnitName: filter?.businessUnit,
    customerMarketUnitName: filter?.marketUnit,
    ibpDemandGroup: filter?.ibpDemandGroup,
    customerTradeSegmentDescription: filter?.cg1TrageSegment,
    salesSectorName: filter?.salesSector,
    salesRegionName: filter?.salesRegion,
    salesZoneName: filter?.zone,
    salesCountryCode: filter?.salesCountry,
    salesOrganizationCode: filter?.businessOrg,
    salesDivisionName: filter?.division,
    forecastEngineClusterId: filter?.clusters,
    forecastModuleCode: filter?.ac1ac2,
    forecastEngineSegmentationId: filter?.segment,
    packageTypeName: filter?.container,
    sector: userData?.currentSector?.sector,
    market: userData?.currentSector?.market,
    // LATAM Key
    flavorName: filter?.flavourNames,
    customerChannelName: filter?.channels,
    customerDemandGroup: filter?.demandGroups,
    customerSubChannelName: filter?.subChannels,
    customerRegionalCluster: filter?.regionalClusters,

    locationGlobalName: filter?.globalCode,
    locationSectorName: filter?.locationSector,
    locationCountryName: filter?.locationCountry,
    planningLocationId: filter?.planningLocationId,
    locationRegionName: filter?.regionCode,
    // PFNA Key
    alternateIBPDemandGroup: filter?.alternateIBPDemandGroup,
  };

  const buildLabelsExp = (response: any[]) => {
    // Create a map of periodWeekNumber to timeFrameDate for sorting
    const labelMap = new Map(
      response?.map((item: any) => [
        item?.periodWeekNumber,
        new Date(item?.timeFrameDate),
      ])
    );

    const labels = Array.from(
      new Set(response?.map((item: any) => item?.periodWeekNumber))
    );

    return labels?.sort((a, b) => {
      const dateA = labelMap.get(a) || new Date(0); // Default to epoch if missing
      const dateB = labelMap.get(b) || new Date(0);

      return dateA.getTime() - dateB.getTime(); // Sort by timeFrameDate ascending
    });
  };

  useEffect(() => {
    setSelectedDataShownOptionList(
      userData?.sections?.predefinedRunsExperimentation?.table?.defaultDataShown
        ?.backTesting
    );
  }, [
    userData?.sections?.predefinedRunsExperimentation?.table?.defaultDataShown
      ?.backTesting,
  ]);

  useEffect(() => {
    function extractExpChartDataPBNA(data: DataPoint[]) {
      const datasets = [
        {
          name: "Statistical Forecast Production",
          data: data
            ?.filter((d) => d.experimentId === "ProductionRun")
            .map((d) => d.statisticalForecast),
          color: "#B992EB",
          type: "line",
          icon: rectanglePink,
          yAxisIndex: 1,
        },

        {
          name: "Statistical Forecast Rank 1",
          data: data
            ?.filter((d) => d.experimentId !== "ProductionRun" && d.rank === 1)
            .map((d) => d.statisticalForecast),
          color: "#85faf7",
          type: "line",
          icon: rectangleBlue,
          yAxisIndex: 1,
        },
        {
          name: "Statistical Forecast Rank 2",
          data: data
            ?.filter((d) => d.experimentId !== "ProductionRun" && d.rank === 2)
            .map((d) => d.statisticalForecast),
          color: "#18f7f7",
          type: "line",
          yAxisIndex: 1,
          icon: rectangleTer,
        },
        {
          name: "Statistical Forecast Rank 3",
          data: data
            ?.filter((d) => d.experimentId !== "ProductionRun" && d.rank === 3)
            .map((d) => d.statisticalForecast),
          color: "#02b3b3",
          type: "line",
          yAxisIndex: 1,
          icon: rectangleAux,
        },
        {
          name: "Historical Shipment (Adjusted)",
          data: data
            ?.filter((d) => d.experimentId === "ProductionRun")
            .map((d) => d.historicalShipment)
            .filter((shipment) => shipment !== 0),
          color: "#FFA800",
          type: "line",
          icon: rectangleYellow,
        },
        {
          name: "Forecast Accuracy Production",
          data: data
            ?.filter((d) => d.experimentId === "ProductionRun")
            .map((d) => d.accuracy),
          color: "#6E3BB2",
          type: "bar",
          yAxisIndex: 0,
          icon: ovalDarkPink,
        },
        {
          name: "Forecast Accuracy Rank 1",
          data: data
            ?.filter((d) => d.experimentId !== "ProductionRun" && d.rank === 1)
            .map((d) => d.accuracy),
          color: "#79b1f8",
          type: "bar",
          yAxisIndex: 0,
          icon: ovalRank1,
        },
        {
          name: "Forecast Accuracy Rank 2",
          data: data
            ?.filter((d) => d.experimentId !== "ProductionRun" && d.rank === 2)
            .map((d) => d.accuracy),
          color: "#0d71f1",
          type: "bar",
          yAxisIndex: 0,
          icon: ovalRank2,
        },
        {
          name: "Forecast Accuracy Rank 3",
          data: data
            ?.filter((d) => d.experimentId !== "ProductionRun" && d.rank === 3)
            .map((d) => d.accuracy),
          color: "#0c3cdf",
          type: "bar",
          yAxisIndex: 0,
          icon: ovalRank3,
        },
      ];

      const allowedRank = filter?.rankBackTestingChart ?? [];
      // Filter datasets based on the applied ranks
      const filterDatasetsBasedOnRank = datasets.filter((dataset) => {
        const name = dataset.name || "";

        // extracting the rank from name
        const match = name.match(/Rank\s*:?(\d)/i);
        const rank = match ? match[1] : null;

        return (
          rank === null ||
          (Array.isArray(allowedRank) && allowedRank.includes(rank as string))
        );
      });
      return filterDatasetsBasedOnRank;
    }

    function extractExpChartDataLATAM(data: DataPoint[]) {
      const datasets = [
        {
          name: "Statistical Forecast Production Measurement Level",
          data: data
            ?.filter(
              (d) =>
                d.experimentId === "ProductionRun" &&
                d.measurement === true &&
                showMeasurement === true
            )
            .map((d) => d.statisticalForecast),
          color: "#8458CC",
          type: "line",
          icon: rectanglePurpleExp,
          yAxisIndex: 1,
        },

        {
          name: "Statistical Forecast Production Output",
          data: data
            ?.filter(
              (d) =>
                d.experimentId === "ProductionRun" &&
                d.measurement === false &&
                showOutput === true
            )
            .map((d) => d.statisticalForecast),
          color: "#CEBCEB",
          type: "line",
          icon: rectanglePurpleLight,
          yAxisIndex: 1,
        },
        {
          name: "Statistical Forecast Rank 1 Measurement Level",
          data: data
            ?.filter(
              (d) =>
                d.experimentId !== "ProductionRun" &&
                d.rank === 1 &&
                d.measurement === true &&
                showMeasurement === true
            )
            .map((d) => d.statisticalForecast),
          color: "#33ABDA",
          type: "line",
          yAxisIndex: 1,
          icon: rectangleBlue,
        },
        {
          name: "Statistical Forecast Rank 1 Output",
          data: data
            ?.filter(
              (d) =>
                d.experimentId !== "ProductionRun" &&
                d.rank === 1 &&
                d.measurement === false &&
                showOutput === true
            )
            .map((d) => d.statisticalForecast),
          color: "#33ABDA",
          type: "line",
          yAxisIndex: 1,
          icon: rectangleBlue,
        },
        {
          name: "Statistical Forecast Rank 2 Measurement Level",
          data: data
            ?.filter(
              (d) =>
                d.experimentId !== "ProductionRun" &&
                d.rank === 2 &&
                d.measurement === true &&
                showMeasurement === true
            )
            .map((d) => d.statisticalForecast),
          color: "#B05788",
          type: "line",
          yAxisIndex: 1,
          icon: rectangleDarkPink,
        },
        {
          name: "Statistical Forecast Rank 2 Output",
          data: data
            ?.filter(
              (d) =>
                d.experimentId !== "ProductionRun" &&
                d.rank === 2 &&
                d.measurement === false &&
                showOutput === true
            )
            .map((d) => d.statisticalForecast),
          color: "#B05788",
          type: "line",
          yAxisIndex: 1,
          icon: rectangleDarkPink,
        },
        {
          name: "Statistical Forecast Rank 3 Measurement Level",
          data: data
            ?.filter(
              (d) =>
                d.experimentId !== "ProductionRun" &&
                d.rank === 3 &&
                d.measurement === true &&
                showMeasurement === true
            )
            .map((d) => d.statisticalForecast),
          color: "#0078A7",
          type: "line",
          yAxisIndex: 1,
          icon: rectangleAux,
        },
        {
          name: "Statistical Forecast Rank 3 Output",
          data: data
            ?.filter(
              (d) =>
                d.experimentId !== "ProductionRun" &&
                d.rank === 3 &&
                d.measurement === false &&
                showOutput === true
            )
            .map((d) => d.statisticalForecast),
          color: "#0078A7",
          type: "line",
          yAxisIndex: 1,
          icon: rectangleAux,
        },
        {
          name: "Historical Shipments (Adjusted)",
          data: data
            ?.filter(
              (d) =>
                d.experimentId === "ProductionRun" && d.measurement === false
            )
            .map((d) => d.historicalShipment)
            .filter((shipment) => shipment !== 0),
          color: "#FFA800",
          type: "line",
          icon: rectangleLightOrange,
        },
        {
          name: "Forecast Accuracy Production",
          data: data
            ?.filter(
              (d) =>
                d.experimentId === "ProductionRun" && d.measurement === false
            )
            .map((d) => d.accuracy),
          color: "#8458CC",
          type: "bar",
          yAxisIndex: 0,
          icon: ovalDarkPink,
        },
        {
          name: "Forecast Accuracy Rank 1",
          data: data
            ?.filter(
              (d) =>
                d.experimentId !== "ProductionRun" &&
                d.rank === 1 &&
                d.measurement === false
            )
            .map((d) => d.accuracy),
          color: "#33ABDA",
          type: "bar",
          yAxisIndex: 0,
          icon: ovalAux,
        },
        {
          name: "Forecast Accuracy Rank 2",
          data: data
            ?.filter(
              (d) =>
                d.experimentId !== "ProductionRun" &&
                d.rank === 2 &&
                d.measurement === false
            )
            .map((d) => d.accuracy),
          color: "#B05788",
          type: "bar",
          yAxisIndex: 0,
          icon: ovalTer,
        },
        {
          name: "Forecast Accuracy Rank 3",
          data: data
            ?.filter(
              (d) =>
                d.experimentId !== "ProductionRun" &&
                d.rank === 3 &&
                d.measurement === false
            )
            .map((d) => d.accuracy),
          color: "#0078A7",
          type: "bar",
          yAxisIndex: 0,
          icon: ovalDarkBlueExp,
        },
      ];

      const allowedRank = filter?.rankBackTestingChart ?? [];

      // const filterDatasetsForLatam = datasets.filter((dataset) => {
      //   const name = dataset.name || "";

      //   const match = name.match(/Rank\s*:?(\d)/i);
      //   const rank = match ? match[1] : null;

      //   return rank !== null && allowedRank.includes(rank);
      // });

      const filterDatasetsForLatam = datasets.filter((dataset) => {
        const name = dataset.name || "";

        // Try to extract rank from name
        const match = name.match(/Rank\s*:?(\d)/i);
        const rank = match ? match[1] : null;

        // Include if:
        // - no rank mentioned in the name (rank is null), OR
        // - rank is in allowed list

        return (
          rank === null ||
          (Array.isArray(allowedRank) && allowedRank.includes(rank as string))
        );
      });

      return filterDatasetsForLatam.filter((dataset) => {
        const name = dataset.name.toLowerCase();
        const isMeasurement = name.includes("measurement");
        const isOutput = name.includes("output");

        if (isMeasurement && !showMeasurement) return false;
        if (isOutput && !showOutput) return false;
        return true;
      });
    }

    {
      /* commented measurement CR changes, will be required in future */
    }
    // setChartDataExp(
    //   userData?.currentSector?.sector === "PBNA" ||
    //     userData?.currentSector?.sector === "PFNA"
    //     ? extractExpChartDataPBNA(expData?.chartData)
    //     : extractExpChartDataLATAM(expData?.chartData)
    // );

    setChartDataExp(extractExpChartDataPBNA(expData?.chartData));

    setChartDataExpLabels(buildLabelsExp(expData?.chartData));
  }, [expData?.chartData, showMeasurement, showOutput]);

  const renderResultVisualizationChartHtml = (): ReactElement => {
    const isLoading = expChartDataLabels?.length < 0;
    // const hasChartData =
    //   expChartData?.length > 0 &&
    //   !expChartData.every((chart: any) =>
    //     chart.data.every((value: any) => value === 0)
    //   );
    // setting chart data flag as true and commenting the previous condition 16-05-2025
    const hasChartData = true;

    if (isLoading) {
      return (
        <div className="flex justify-center">
          <img
            src={loadingSvg}
            alt="loading"
            className="mt-10"
            width={40}
            height={40}
          />
        </div>
      );
    }

    if (
      hasChartData &&
      expChartData &&
      expChartData?.length > 0 &&
      expChartDataLabels &&
      expChartDataLabels?.length &&
      isValidBackTestingChart(expChartData)
    ) {
      return (
        <LineColumnChartExp
          seriesData={expChartData}
          columnWidth={"4"}
          labels={expChartDataLabels}
        />
      );
    }

    return <></>;
  };

  const handleSettingModal = () => {
    mapperForGroupByLableToKeyHandler(selectedDataShownOptionList);
    setOpenSettings(true);
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = event.target;
    if (value === "measurement") {
      setShowMeasurement(checked);
    } else if (value === "output") {
      setShowOutput(checked);
    }
  };

  const renderBackTestingTableHtml = (): ReactElement => {
    return (
      <>
        {resultVisulizationExperimentBackTestingTableDataSlice?.isTableDataLoading ? (
          <div className="flex justify-center">
            <img
              src={loadingSvg}
              alt="loading"
              className="mt-10"
              width={40}
              height={40}
            />
          </div>
        ) : (
          <BacktestingResultTable
            tableHeader={
              resultVisulizationExperimentBackTestingTableDataSlice?.tableHeader
            }
            tableArea="ExperimentationBackTesting"
            chartData={[]}
            backTestingTableData={
              resultVisulizationExperimentBackTestingTableDataSlice?.backTestingTableData
            }
            payloadForExcel={{
              ...payloadFilters,
              pageNumber: 1,
              pageSize: 1000,
              groupBy:
                payloadExcelGroup.length > 0
                  ? payloadExcelGroup
                  : userData?.currentSector?.sector === "LATAM"
                  ? [
                      "ForecastEngineClusterId",
                      "BusinessReportingMaterialId",
                      "BusinessReportingCustomerId",
                      "BusinessReportingLocationId",
                    ]
                  : [
                      "ForecastEngineClusterId",
                      "MaterialGlobalTradeItemNumberDescription",
                      "MaterialGlobalTradeItemNumber",
                      "DemandPlanningKeyAccountId",
                      "DemandPlanningKeyAccountName",
                      "SalesRegionName",
                    ],
              rank: filter?.rankBackTestingChart.map(Number),
            }}
            isResultVisulizationPage={isResultVisulizationPage}
            resultVisulizationTableData={
              resultVisualizationExperimentationData.chartData
            }
            isExperimentationPage={true}
            measurementPayload={measurementPayload}
            isPredefined={isPredefined}
          />
        )}
      </>
    );
  };

  const mapperForGroupByLableToKeyHandler = (
    selectedItemList: string[] = []
  ) => {
    // restrict keys to be passed to API based on AC1/AC2 selection in PFNA
    const groupByPFNAData =
      userData?.currentSector?.sector === "PFNA" &&
      filter?.ac1ac2?.[0] !== undefined &&
      filter?.ac1ac2?.[0] === "AC1"
        ? selectedItemList?.filter(
            (item) => item !== "Planning Item" && item !== "UPC"
          )
        : selectedItemList;

    const { selectedGroupByOptions, selectedCategoryType } =
      mapperForGroupByLableToKey(groupByPFNAData, dataShowKeyValueMappings);
    setSelectedDataShownOptionList(selectedItemList);
    setSelectedDataShownCategoryList(selectedCategoryType);

    return selectedGroupByOptions;
  };

  const updateBackTestingTableData = (selectedOptionList: string[]) => {
    const groupByKeys = mapperForGroupByLableToKeyHandler(selectedOptionList);

    setPayloadExcelGroup(groupByKeys);
    const forecastBackTestingApiRequestBody = {
      ...payloadFilters,
      pageNumber: 1,
      pageSize: PAGE_LIMIT,
      groupBy: mapperForGroupByLableToKeyHandler(selectedOptionList),
      rank: filter?.rankBackTestingChart.map(Number),
    };

    setOpenSettings(false);
    dispatch(
      resultVisulizationExperimentBackTestingTableDataSetter({
        tableHeader: [],
        backTestingTableData: [],
        isTableDataLoading: true,
      })
    );

    resultVisualisationChartExperimentaionTableApi(
      forecastBackTestingApiRequestBody,
      authState
    )
      .then((response) => {
        const totalBackTestingPages = calculateTotalPages(
          PAGE_LIMIT,
          response?.totalCount
        );
        dispatch(
          updateExperinemtBackTestingTotalPages({
            totalPages: totalBackTestingPages,
            pageLimit: resultVisulizationBackTestingPaginationDate.pageLimit,
            pageNumber: resultVisulizationBackTestingPaginationDate.pageNumber,
            isDataShownClicked:
              resultVisulizationBackTestingPaginationDate.isDataShownClicked,
          })
        );
        dispatch(
          resultVisulizationExperimentBackTestingTableDataSetter({
            tableHeader: response?.dynamicTableHeader,
            backTestingTableData: response?.dfuBasedGroupedData,
            isTableDataLoading: false,
          })
        );
      })
      .catch((error) => {
        console.log("forecastBackTestingTableApi error", error);
      });
  };

  const onModalClosed = () => {
    setOpenSettings(false);
  };

  const renderBackTestingDataShownModalHtml = (
    handleCheckboxChange: any
  ): ReactElement => {
    return (
      <>
        <DataShownDialog
          open={openSettings}
          defaultSelectedOptions={selectedDataShownOptionList}
          categoryList={selectedDataShownCategoryList}
          onClose={(itemList) => updateBackTestingTableData(itemList)}
          onModalClosed={onModalClosed}
          showModel={true}
          resetOptions="ExperimentBackTesting"
        />
        <Modal open={open} onClose={handleClose}>
          <Box
            sx={{
              position: "absolute" as const,
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "80%",
              bgcolor: "#272727",
              boxShadow: 24,
              borderRadius: 2,
            }}
          >
            <div className="m-4">
              <div className="flex justify-between p-4">
                <h6 className="font-bold text-white">Backtesting Results</h6>
                <button onClick={handleClose}>
                  <img src={closeButton} alt="close" />
                </button>
              </div>

              {/* commented measurement CR changes, will be required in future */}
              {/* {userData?.sections?.predefinedRuns?.measurementEnabled ? (
                <div className="measurement-box font-bold text-white">
                  <FormGroup
                    sx={{
                      position: "flex",
                      flexDirection: "row",
                      alignItems: "left",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={showMeasurement}
                          value={"measurement"}
                          onChange={handleCheckboxChange}
                        />
                      }
                      label="Measurement Level"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={showOutput}
                          value={"output"}
                          onChange={handleCheckboxChange}
                        />
                      }
                      label="Output Level"
                    />
                  </FormGroup>
                </div>
              ) : (
                ""
              )} */}

              <div className="bg-ternary-bg rounded m-4">
                {expChartData &&
                  expChartData?.length > 0 &&
                  expChartDataLabels &&
                  expChartDataLabels?.length &&
                  isValidBackTestingChart(expChartData) && (
                    <>
                      <LineColumnChartExp
                        seriesData={expChartData}
                        columnWidth={"4"}
                        labels={expChartDataLabels}
                      />
                      <BacktestingResultTable
                        tableHeader={
                          resultVisulizationExperimentBackTestingTableDataSlice?.tableHeader
                        }
                        chartData={[]}
                        backTestingTableData={
                          resultVisulizationExperimentBackTestingTableDataSlice?.backTestingTableData
                        }
                        isResultVisulizationPage={isResultVisulizationPage}
                        resultVisulizationTableData={
                          resultVisualizationExperimentationData?.chartData
                        }
                        tableArea="ExperimentationBackTesting"
                        payloadForExcel={{
                          ...payloadFilters,
                          pageNumber: 1,
                          pageSize: 1000,
                          groupBy:
                            payloadExcelGroup.length > 0
                              ? payloadExcelGroup
                              : userData?.currentSector?.sector === "LATAM"
                              ? [
                                  "ForecastEngineClusterId",
                                  "BusinessReportingMaterialId",
                                  "BusinessReportingCustomerId",
                                  "BusinessReportingLocationId",
                                ]
                              : [
                                  "ForecastEngineClusterId",
                                  "MaterialGlobalTradeItemNumberDescription",
                                  "MaterialGlobalTradeItemNumber",
                                  "DemandPlanningKeyAccountId",
                                  "DemandPlanningKeyAccountName",
                                  "SalesRegionName",
                                ],
                        }}
                        isExperimentationPage={true}
                        measurementPayload={measurementPayload}
                        isPredefined={isPredefined}
                      />
                    </>
                  )}
                {resultVisulizationExperimentBackTestingTableDataSlice?.isTableDataLoading && (
                  <div className="flex justify-center">
                    <img
                      src={loadingSvg}
                      alt="loading"
                      className="mt-10"
                      width={40}
                      height={40}
                    />
                  </div>
                )}
              </div>
            </div>
          </Box>
        </Modal>
      </>
    );
  };

  const renderBackTestingHtml = (): ReactElement => {
    const isDataEmpty =
      !resultVisulizationExperimentTestingDataLoadingSlice?.isDataLoading &&
      resultVisulizationExperimentBackTestingTableDataSlice
        ?.backTestingTableData?.length === 0 &&
      resultVisualizationExperimentationData?.chartData?.length === 0;

    let content;

    if (isDataEmpty) {
      content = loader ? (
        <div className="bg-ternary-bg rounded p-2">
          <div className="flex justify-center">
            <p className="p-2 m-1">
              No Data to show or no options selected, please choose from the
              above filters.
            </p>
          </div>
        </div>
      ) : (
        <div className="flex justify-center">
          <img
            src={loadingSvg}
            alt="loading"
            className="mt-10"
            width={40}
            height={40}
          />
        </div>
      );
    } else {
      content = (
        <>
          {/* commented measurement CR changes, will be required in future */}
          {/* {userData?.sections?.predefinedRuns?.measurementEnabled ? (
            <div className="measurement-box">
              <FormGroup
                sx={{
                  position: "flex",
                  flexDirection: "row",
                  alignItems: "left",
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={showMeasurement}
                      value={"measurement"}
                      onChange={handleCheckboxChange}
                    />
                  }
                  label="Measurement Level"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={showOutput}
                      value={"output"}
                      onChange={handleCheckboxChange}
                    />
                  }
                  label="Output Level"
                />
              </FormGroup>
            </div>
          ) : (
            ""
          )} */}
          <div className="bg-ternary-bg rounded">
            {renderResultVisualizationChartHtml()}
            {renderBackTestingTableHtml()}
          </div>
          {renderBackTestingDataShownModalHtml(handleCheckboxChange)}
        </>
      );
    }

    return content;
  };

  const handlePageNumberUpdateEvent = (currentPageNumber: number) => {
    dispatch(
      updateExperinemtBackTestingPageNumber({
        pageLimit: resultVisulizationBackTestingPaginationDate?.pageLimit,
        pageNumber: currentPageNumber,
        totalPages: resultVisulizationBackTestingPaginationDate?.totalPages,
        isDataShownClicked: false,
        groupBySelectedField: selectedDataShownOptionList,
      })
    );
  };

  return (
    <div className="p-5 bg-secondary-bg mt-4 rounded">
      <div className="flex justify-between">
        <div className="flex mb-2">
          <h6 className="text-lg font-bold mb-4 mt-2 pt-2">
            Backtesting Results
          </h6>
          {lagDropdownData?.experimentLoader ? (
            <div className="flex justify-center">
              <img
                src={loadingSvg}
                alt="loading"
                className="mt-2 px-2"
                width={40}
                height={40}
              />
            </div>
          ) : (
            userData?.sections?.predefinedRunsExperimentation?.table
              ?.lagDropdown && <LagDropdown />
          )}
          <RankDropdownForward rankType="rankBackTestingChart" />
        </div>
        {!resultVisulizationExperimentTestingDataLoadingSlice?.isDataLoading ||
        resultVisulizationExperimentBackTestingTableDataSlice
          ?.backTestingTableData?.length > 0 ? (
          <div>
            <button onClick={handleSettingModal}>
              <img
                className="mr-5"
                width={20}
                height={20}
                src={settingsIcon}
                alt="settingsIcon"
              />
            </button>
            <button onClick={handleOpen}>
              <img src={enlargeButton} alt="zoom" />
            </button>
          </div>
        ) : null}
      </div>
      <>
        {renderBackTestingHtml()}
        <div className="flex justify-center">
          {resultVisulizationExperimentBackTestingTableDataSlice
            ?.backTestingTableData?.length > 0 && (
            <div className="pt-2">
              <Pagination
                totalPages={
                  resultVisulizationBackTestingPaginationDate?.totalPages
                }
                activePageNumber={
                  resultVisulizationBackTestingPaginationDate?.pageNumber
                }
                updateBackTestingPageNumber={(data) =>
                  handlePageNumberUpdateEvent(data)
                }
              />
            </div>
          )}
        </div>
      </>
    </div>
  );
}

export default ResultVisulizationExperimentBacktestingResults;
